import { render, staticRenderFns } from "./Planner.vue?vue&type=template&id=45b5836b&scoped=true&"
import script from "./Planner.vue?vue&type=script&lang=js&"
export * from "./Planner.vue?vue&type=script&lang=js&"
import style0 from "./Planner.vue?vue&type=style&index=0&id=45b5836b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b5836b",
  null
  
)

export default component.exports